import './style.scss';

export function products_block() {
    const block = document.querySelector('.products_block');
    if (!block) return;

}
